<template>
  <Modal v-if="showModal" @close="closeModal()">
    <div class="p-modal__content__header">
      {{
        $t('pages.CompaniesTestimonials.errorModal.errorCount', {
          value: errors.length,
        })
      }}
    </div>
    <div class="p-box__body">
      <div class="p-table__content">
        <table>
          <thead>
            <tr>
              <th>
                {{ $t('pages.CompaniesTestimonials.errorModal.line') }}
              </th>
              <th>
                {{ $t('pages.CompaniesTestimonials.errorModal.reason') }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(error, i) in errors" :key="i">
              <td>
                {{
                  $t('pages.CompaniesTestimonials.errorModal.errorLine', {
                    value: error.lineNumber,
                  })
                }}
              </td>
              <td>
                {{ `${ $t(`pages.CompaniesTestimonials.errorModal.errors.${error.attr}`) }が${ $t(`pages.CompaniesTestimonials.errorModal.errors.${error.reason}`) }` }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </Modal>
</template>

<script>
import Modal from '../../Modal.vue'

export default {
  name: 'CompaniesTestimonialsFilesErrorModal',
  components: {
    Modal,
  },
  props: {
    showModal: Boolean,
    errors: Array,
  },
  emits: ['close-modal'],
  methods: {
    closeModal() {
      this.$emit('close-modal')
    },
  }
}
</script>
<style lang="scss" scoped>
.p-box__body {
  height: 400px;
  overflow-y: scroll;
  &::-webkit-scrollbar {
    width: 10px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 50, .5);
    border-radius: 10px;
    box-shadow: 0 0 0 1px rgba(255, 255, 255, .3);
  }
}
</style>
